import { render, staticRenderFns } from "./WelcomeSignOverrideModal.vue?vue&type=template&id=5a021415"
import script from "./WelcomeSignOverrideModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeSignOverrideModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports